module.exports = __webpack_public_path__ + "img/js1.256a3165.jpg";